export default __webpack_public_path__ + "images/pages/the_lounge/arrow-left-mobile-d623a98ff308ed04c01627ed922ba110.svg";